// Single source of truth for the Jordan cities the admin panel
// references (driver service-area filtering, order pickup display, etc.).
// Order matters: Amman is first so it surfaces at the top of dropdowns
// and chip lists.
export const CITIES = [
  { key: 'amman',   en: 'Amman',    ar: 'عمّان' },
  { key: 'irbid',   en: 'Irbid',    ar: 'إربد' },
  { key: 'zarqa',   en: 'Zarqa',    ar: 'الزرقاء' },
  { key: 'mafraq',  en: 'Mafraq',   ar: 'المفرق' },
  { key: 'jerash',  en: 'Jerash',   ar: 'جرش' },
  { key: 'ajloun',  en: 'Ajloun',   ar: 'عجلون' },
  { key: 'balqa',   en: 'Balqa',    ar: 'البلقاء' },
  { key: 'madaba',  en: 'Madaba',   ar: 'مادبا' },
  { key: 'karak',   en: 'Karak',    ar: 'الكرك' },
  { key: 'tafilah', en: 'Tafilah',  ar: 'الطفيلة' },
  { key: 'maan',    en: "Ma'an",    ar: 'معان' },
  { key: 'aqaba',   en: 'Aqaba',    ar: 'العقبة' },
];

export const CITY_KEYS = CITIES.map((c) => c.key);

export function cityName(key, locale = 'en') {
  const c = CITIES.find((x) => x.key === key);
  if (!c) return key;
  return locale === 'ar' ? c.ar : c.en;
}
